import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import { api, eur, dt, download } from "@/lib/api";
import { useAuth, isAgent } from "@/context/AuthContext";
import { PageHeader, Panel, Empty } from "@/components/Common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const meseOggi = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`; };
const stampa = (mese, agente_id) => download("/provvigioni/pdf", { mese, agente_id }).catch((e) => toast.error(e.message));

const Agente = ({ a, mese }) => (
  <Panel title={`${a.nome} · ${a.percentuale}% base · ${a.clienti} clienti`} className="mb-6"
    action={<Button size="sm" variant="outline" data-testid={`commission-print-${a.agente_id}`} onClick={() => stampa(mese, a.agente_id)}><Printer className="mr-1 h-4 w-4" />Tabulato PDF</Button>}>
    {a.righe.length === 0 ? <Empty text="Nessuna fattura nel mese per i clienti abbinati" /> : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b text-left text-xs uppercase text-slate-500"><th className="py-2">Fattura</th><th>Cliente</th><th className="text-right">Imponibile</th><th className="text-right">%</th><th className="text-right">Provvigione</th></tr></thead>
          <tbody>
            {a.righe.map((r) => (
              <tr key={r.invoice_id} className="border-b border-slate-100">
                <td className="py-2 font-mono">{r.numero} <span className="text-xs text-slate-500">{dt(r.data)}</span></td>
                <td>{r.cliente}{r.tipo === "TD04" && <span className="ml-1 text-xs text-rose-600">nota di credito</span>}</td>
                <td className="text-right font-mono">{eur(r.imponibile)}</td><td className="text-right">{r.percentuale}%</td><td className="text-right font-mono">{eur(r.provvigione)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
    <div className="mt-3 flex justify-end gap-6 text-sm" data-testid={`commission-total-${a.agente_id}`}>
      <span>Imponibile <b className="font-mono">{eur(a.imponibile)}</b></span><span className="text-base text-emerald-800">Provvigione <b className="font-mono">{eur(a.provvigione)}</b></span>
    </div>
  </Panel>
);

export default function Provvigioni() {
  const { user } = useAuth();
  const [mese, setMese] = useState(meseOggi());
  const [d, setD] = useState(null);
  useEffect(() => { if (mese) api.get("/provvigioni", { params: { mese } }).then((r) => setD(r.data)); }, [mese]);
  return (
    <div>
      <PageHeader title={isAgent(user) ? "Le mie provvigioni" : "Provvigioni agenti"} subtitle="Calcolate sull'imponibile delle fatture emesse nel mese ai clienti abbinati">
        <Input type="month" data-testid="commission-month-input" className="w-44 bg-white" value={mese} onChange={(e) => setMese(e.target.value)} />
        {!isAgent(user) && d?.length > 1 && <Button variant="outline" className="bg-white" data-testid="commission-print-all" onClick={() => stampa(mese)}><Printer className="mr-2 h-4 w-4" />Tabulato di tutti</Button>}
      </PageHeader>
      {d === null ? null : d.length === 0 ? <Empty text="Nessun agente di vendita: crealo in Utenti con il ruolo Agente di vendita" /> : d.map((a) => <Agente key={a.agente_id} a={a} mese={mese} />)}
    </div>
  );
}
